import React, { useEffect, useCallback, useState} from 'react';
import ExportProgressBar from "components/progressbar/ExportProgressBar.js";
import {bounce} from 'engine/BouncingEngine.js';
import {connect} from 'react-redux';
import {MASTER, GROUPS} from 'constants/render-options.js';
import {getTrackLength} from './getTrackLength.js';

const ExportHelper = ({sequencerEngine, loadingProgress, option=MASTER}) => { 
    let [bouncing, setBouncing] = useState(false);
    useEffect(() => {
        if (loadingProgress === 100) {
            // then we export
            setBouncing(true);
            let trackLength = getTrackLength(sequencerEngine);
            bounce(sequencerEngine, trackLength, option, true)
                .then(() => {
                    window.exportCompleted = true;
                    setBouncing(false);
                });
        }
    }, [loadingProgress, setBouncing, sequencerEngine, option]);

    return (
        <div>
          <ExportProgressBar renderLength={8}/>
        </div>);
}

const mapStateToProps = (state, {sequencerEngine, id})=> {
  return {
      loadingProgress: state.sequencer.sequenceLoadingProgress[id || (sequencerEngine && sequencerEngine.sequenceId)] || 0
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExportHelper);
